import React from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { getFillStyles, trackStyles } from './SubmissionProgressBar.styles';

const SubmissionProgressBar = ({ percent }) => (
  <Box sx={trackStyles}>
    <Box sx={getFillStyles(percent)} />
  </Box>
);

SubmissionProgressBar.propTypes = {
  percent: PropTypes.number.isRequired,
};

export default SubmissionProgressBar;
